require('./bootstrap');
require('./common');
require('./top');
require('./my');
require('./blog');
require('./community');
require('./event');
require('./movie');
require('./shopping');
require('./reservation');
require('./auth');


